import { render } from "./EditTripForm.vue?vue&type=template&id=4543e5e6&scoped=true&ts=true"
import script from "./EditTripForm.vue?vue&type=script&lang=ts"
export * from "./EditTripForm.vue?vue&type=script&lang=ts"

import "./EditTripForm.vue?vue&type=style&index=0&id=4543e5e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4543e5e6"]])

export default __exports__